import { useCheckAccountTraits } from '@cmg/auth';

export const useCanViewSellSideMyDataLab = (): boolean => {
  // This is the only sell side MDL functionality.
  // As more sell side MDL functionality is added, this condition will be expanded.
  return useCheckAccountTraits(['DEMAND_ANALYTICS']);
};
